export default function identity(any = null) {
    return any
}
